export default function retrieveInvalidFields(validator, instance){
	return Object.entries(validator)
		.filter(([, willValidate]) => !willValidate.length) // remove validates with dependencies
		.filter(([key, willValidate]) => !willValidate().apply(instance, [instance[key], key]))
		.map(([key]) => key);
}
